import { IUsersAnalytics, ActivityLogItem } from "./IUsersAnalytics";
import { IUser } from "../../../../model/ModelTypes";
import { isNullOrUndefined } from "util";
import * as moment from 'moment';
import { Observable, Observer } from "rxjs";

export class UsersAnalytics implements IUsersAnalytics {
    private users: IUser[];
    private usersCountPerMonth: Map<string, number>;
    private usersCountPerYear: Map<string, number>;
    private submittedResultsPerMonth: Map<string, number>;
    public static Build(users: IUser[]): Observable<IUsersAnalytics> {
        return Observable.create((observer: Observer<IUsersAnalytics>) => {
            observer.next(new UsersAnalytics(users));
            observer.complete();
        });
    }
    getUsers(): IUser[] {
        return this.users.filter(user => (!isNullOrUndefined(user.username)) &&
            (user.username.replace(/\s/g, '') !== '' ));
    }

    getUsersCount(): number {
        return this.getUsers().length;
    }
    getUserCountPerMonth(): Map<string, number> {
        return this.usersCountPerMonth;
    }
    getAvgNewUserPerMonth(): number {
        let totalCount = 0;
        this.usersCountPerMonth.forEach( value => {
            totalCount += value;
        });

        return totalCount / this.usersCountPerMonth.size;
    }
    getAvgNewUserPerYear(): number {
        let totalCount = 0;
        this.usersCountPerYear.forEach( value => {
            totalCount += value;
        });

        return totalCount / this.usersCountPerYear.size;
    }
    getSubmittedResultsCount(): number {
        let total = 0;
        this.submittedResultsPerMonth.forEach( value => total += value);
        return total;
    }
    getSubmittedResultsCountPerMonth(): Map<string, number> {
        return this.submittedResultsPerMonth;
    }
    getAvgDailyActiveUsers(): number {
        throw new Error("Method not implemented.");
    }
    getAvgMonthlyActiveUsers(): number {
        throw new Error("Method not implemented.");
    }
    getAvgYearlyActiveUsers(): number {
        throw new Error("Method not implemented.");
    }
    getActivityLog() {
        return this.getUsersUpdatesActivityLog()
        .concat(
            this.getResultsSubmissionsActivityLog()
        )
        .sort(
            (a, b) => b.timestamp - a.timestamp
        );
    }
    private getResultsSubmissionsActivityLog(): ActivityLogItem[] {
        let log: ActivityLogItem[] = []; 
        this.users.forEach(
            user => {
                if (!isNullOrUndefined(user.results)) {
                     user.results.forEach( result => {
                        if (!isNullOrUndefined(result.submit_time)) {
                            let date = moment(result.submit_time);
                            if (date.isValid()) {
                                log.push(
                                    {
                                        date: date.format("DD.MM.YYYY"),
                                        time: date.format("HH:mm"),
                                        description: `${user.name} submitted a result`,
                                        timestamp: date.valueOf()
                                    }
                                );
                            }
                        }
                    });
                } 
            }
        );
        return log;
    }
    private getUsersUpdatesActivityLog(): ActivityLogItem[] {
        let log: ActivityLogItem[] = [];
        this.getUsers().forEach(
            user => {
                if (!isNullOrUndefined(user.updated_time)) {
                    let date = moment(user.updated_time);
                    if (date.isValid()) {
                        log.push({
                                     date: date.format("DD.MM.YYYY"),
                                     time: date.format("HH:mm"),
                                     description: `${user.name} became an active user`,
                                     timestamp: date.valueOf()
                                 });
                    }
                }
            }
        );
        return log;
    }
    // private getActiveUsersActivityLog(): ActivityLogItem[] {
    //     let log: ActivityLogItem[] = [];
    //     this.getUsers().forEach(
    //         user => {
    //             if (!isNullOrUndefined(user.created_time)) {
    //                let date = moment(user.created_time);
    //                if (date.isValid()) {
    //                    log.push({
    //                                 date: date.format("DD.MM.YYYY"),
    //                                 time: date.format("HH:mm"),
    //                                 description: `${user.name} became an active user`,
    //                                 timestamp: date.valueOf()
    //                             });
    //                }
    //             }
    //         }
    //     );
    //     return log;
    // }
    private buildusersCountPerMonthMap(user: IUser) {
        if (!isNullOrUndefined(user.created_time)) {
            let createdDate = moment(user.created_time).toDate();
            let monthlyCount = this
            .usersCountPerMonth
            .get(`${createdDate.getMonth()} ${createdDate.getFullYear()}`);
            if (isNullOrUndefined(monthlyCount)) {
                monthlyCount = 0;
            }

            this
            .usersCountPerMonth
            .set(`${createdDate.getMonth()} ${createdDate.getFullYear()}`, monthlyCount + 1);
        }
    }

    private buildusersCountPerYearMap(user: IUser) {
        if (!isNullOrUndefined(user.created_time)) {
            let createdDate = moment(user.created_time).toDate();
            let yearlyCount = this
            .usersCountPerYear
            .get(`${createdDate.getFullYear()}`);
            if (isNullOrUndefined(yearlyCount)) {
                yearlyCount = 0;
            }

            this
            .usersCountPerYear
            .set(`${createdDate.getFullYear()}`, yearlyCount + 1);
        }
    }

    private buildsubmittedResultsPerMonthMap(user: IUser) {
            if (!isNullOrUndefined(user.results)) {
                user.results.forEach( result => {
                    if (!isNullOrUndefined(result.submit_time)) {
                        let submissionDate = moment(result.submit_time).toDate();
                        let count = this
                        .submittedResultsPerMonth
                        .get(`${submissionDate.getMonth()} ${submissionDate.getFullYear()}`);
                        if ( !isNullOrUndefined(count)) {
                            count += 1;
                        } else {
                            count = 1;
                        }
                        this
                        .submittedResultsPerMonth
                        .set(`${submissionDate.getMonth()} ${submissionDate.getFullYear()}`, count);
                    }
                });
            }
        
    }

    private constructor (users: IUser[]) {
        this.users = users;
        this.usersCountPerMonth = new Map();
        this.usersCountPerYear = new Map();
        this.submittedResultsPerMonth = new Map();
        users.forEach( user => {
            this.buildusersCountPerMonthMap(user);
            this.buildusersCountPerYearMap(user);
            this.buildsubmittedResultsPerMonthMap(user);
        });
    }

}


// WEBPACK FOOTER //
// ./src/utility/admin/UsersControls/UsersAnalytics/UsersAnalytics.ts